import { render, staticRenderFns } from "./shipment-bill-product-detail.vue?vue&type=template&id=5cd0ea55&scoped=true&"
import script from "./shipment-bill-product-detail.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-product-detail.vue?vue&type=script&lang=js&"
import style0 from "./shipment-bill-product-detail.vue?vue&type=style&index=0&id=5cd0ea55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0ea55",
  null
  
)

export default component.exports